//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Common from '@/components/user/accessCommon';
import { frameUserApi } from '@/api/setting';
export default {
  name: 'FormBox',
  components: {
    dateQuarter: function dateQuarter() {
      return import('@/components/form-common/select-dateQuarter');
    },
    manageRange: function manageRange() {
      return import('@/components/form-common/select-manageRange');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    frameUserType: {
      Frame: Number,
      default: 0
    },
    handle: {
      Frame: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      fromList: [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('user.work.backlog'),
        val: 0
      }, {
        text: this.$t('user.work.done'),
        val: 1
      }],
      pickerOptions: this.$pickerOptionsTimeEle,
      timeVal: [],
      userList: [],
      tableFrom: {
        matter: '',
        period: '',
        scope_frame: 'all',
        test_uid: '',
        cycle: '',
        time: '',
        data: '',
        times: ''
      },
      periodOptions: Common.periodOption,
      type: 0,
      statusOptions: Common.statusOptions,
      title: '',
      frameUserArray: [],
      frameUserOption: [],
      dateArray: [{
        value: 1,
        type: 'week',
        text: '选择周',
        format: 'yyyy 第 WW 周'
      }, {
        value: 2,
        type: 'month',
        text: '选择月份',
        format: 'yyyy-MM'
      }, {
        value: 4,
        type: ''
      }, {
        value: 5,
        type: ''
      }, {
        value: 3,
        type: 'year',
        text: '选择年份',
        format: 'yyyy'
      }],
      quarterBtn: false,
      halfYearBtn: false
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    },
    handle: function handle() {
      this.reset();
    }
  },
  mounted: function mounted() {},
  methods: {
    setOptions: function setOptions() {
      this.fromList = [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('user.work.backlog'),
        val: 0
      }, {
        text: this.$t('user.work.done'),
        val: 1
      }];
    },
    // 选择管理范围完成回调
    changeMastart: function changeMastart(data) {
      this.tableFrom.scope_frame = data;
      this.$emit('confirmData', this.tableFrom);
    },
    // 选择成员完成回调
    getSelectList: function getSelectList(data) {
      this.userList = data;
      var testUid = [];
      this.userList.forEach(function (item) {
        testUid.push(item.value);
      });
      this.tableFrom.test_uid = testUid;
      this.$emit('confirmData', this.tableFrom);
    },
    selectPeriod: function selectPeriod(e) {
      var _this = this;
      // 切换季度半年考核
      if (e == 4) {
        this.quarterBtn = true;
        this.halfYearBtn = true;
        this.$nextTick(function () {
          _this.$refs.dateQuarter.showValue = '';
        });
      } else if (e == 5) {
        this.quarterBtn = true;
        this.halfYearBtn = false;
        this.$nextTick(function () {
          _this.$refs.dateQuarter.showValue = '';
        });
      } else {
        this.quarterBtn = false;
      }
      if (e === '') {
        this.tableFrom.date = '';
      } else {
        this.timeVal = [];
        this.tableFrom.time = '';
        this.tableFrom.times = '';
      }
      this.$emit('confirmData', this.tableFrom);
    },
    changeCycle: function changeCycle() {
      this.$emit('confirmData', this.tableFrom);
    },
    // 重置
    reset: function reset() {
      var _this2 = this;
      this.timeVal = [];
      this.tableFrom = {
        matter: this.handle,
        period: '',
        scope_frame: 'all',
        test_uid: '',
        cycle: '',
        time: '',
        data: '',
        times: ''
      };
      this.userList = [];
      setTimeout(function () {
        if (_this2.$refs.manageRange) {
          _this2.$refs.manageRange.frame_id = 'all';
        }
      }, 300);
      this.$emit('confirmData', this.tableFrom);
    },
    // 选择时间区域
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.tableFrom.time = '';
        this.tableFrom.times = '';
        this.confirmData();
      } else {
        if (this.tableFrom.period === 4 || this.tableFrom.period === 5) {
          this.$refs.dateQuarter.showValue = '';
        }
        this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.times = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.date = '';
        this.confirmData();
      }
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.confirmData();
    },
    getFrameUser: function getFrameUser() {
      var _this3 = this;
      var data = {
        type: this.frameUserType
      };
      this.frameUserOption = [];
      frameUserApi(data).then(function (res) {
        res.data == undefined ? _this3.frameUserArray = [] : _this3.frameUserArray = res.data;
        if (_this3.frameUserArray.length > 0) {
          if (_this3.frameUserType === 1) {
            _this3.frameUserArray.forEach(function (value) {
              _this3.frameUserOption.push({
                value: value.user_ent.id,
                label: value.name
              });
            });
          } else {
            _this3.frameUserArray.forEach(function (value) {
              _this3.frameUserOption.push({
                value: value.id,
                label: value.card.name
              });
            });
          }
        }
      });
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', this.tableFrom);
    },
    getPeriodText: function getPeriodText(id) {
      var txt = Common.getPeriodText(id);
      return txt;
    },
    getStatusText: function getStatusText(id) {
      var txt = Common.getStatusText(id);
      return txt;
    },
    getStatusTag: function getStatusTag(status) {
      return Common.getStatusTag(status);
    },
    changePeriod: function changePeriod(e) {
      var _this4 = this;
      // 切换季度半年考核
      if (e == 4) {
        this.quarterBtn = true;
        this.halfYearBtn = true;
        this.$nextTick(function () {
          _this4.$refs.dateQuarter.showValue = '';
        });
      } else if (e == 5) {
        this.quarterBtn = true;
        this.halfYearBtn = false;
        this.$nextTick(function () {
          _this4.$refs.dateQuarter.showValue = '';
        });
      } else {
        this.quarterBtn = false;
      }
    },
    getDateValue: function getDateValue(e) {
      this.timeVal = [];
      if (!e) {
        this.tableFrom.date = '';
      } else {
        if (this.tableFrom.period == 1) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        } else if (this.tableFrom.period == 2) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        } else if (this.tableFrom.period == 3) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        }
      }
      this.confirmData();
    },
    getQuarterDate: function getQuarterDate(data) {
      this.tableFrom.date = this.getQuarterTime(this.tableFrom.period, data);
      this.timeVal = [];
      this.tableFrom.times = '';
      this.tableFrom.time = '';
      this.confirmData();
    },
    getQuarterTime: function getQuarterTime(type, time) {
      if (!time) return false;
      var str = '';
      var timeArr = time.split('-');
      var year = timeArr[0];
      var month = timeArr[1];
      if (type === 5) {
        if (month === '01') {
          str = year + '-01-01 00:00:00';
        } else if (month === '02') {
          str = year + '-04-01 00:00:00';
        } else if (month === '03') {
          str = year + '-07-01 00:00:00';
        } else if (month === '04') {
          str = year + '-10-01 00:00:00';
        }
      } else if (type === 4) {
        if (month === '01') {
          str = year + '-01-01 00:00:00';
        } else if (month === '02') {
          str = year + '-07-01 00:00:00';
        }
      }
      return str;
    }
  }
};